import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { TokenRefreshService } from 'projects/service/src/app/shared/services/token-refresh.service';
import { ErrorHandlerService } from 'projects/service/src/app/shared/services/error-handler.service';

@Injectable({
    providedIn: 'root'
})
export class AuthService {
    getToken(): string | null {
      return localStorage.getItem('access_token');
    }

    isLogged: boolean = false;
    redirectUrl: string; // if user is not logged in user will be redirected to the accessed page after login
    route;

    constructor(
        private http: HttpClient,
        private router: Router,
        private tokenRefreshService: TokenRefreshService,
        private errorHandler: ErrorHandlerService,
    ) {
        // this.isLogged = !!window.localStorage.getItem('access_token');


        // this.tokenRefreshService.startTokenRefresh()
        //     .subscribe(
        //         (res: any) => {
        //             if (res) {
        //                 localStorage.removeItem('access_token');
        //                 localStorage.removeItem('refresh_token');
        //                 localStorage.removeItem('token_expiry');
        //                 localStorage.setItem('access_token', res.accessToken);
        //                 localStorage.setItem('refresh_token', res.refreshToken);
        //                 localStorage.setItem('token_expiry', '' + new Date(res.expiration).getTime());
        //                 this.tokenRefreshService.calculateIntervalDuration();
        //             }
        //         }, // Log success or handle error
        //         (error) => {
        //             localStorage.clear();
        //             this.errorHandler.handleHttpError(error);
        //         }
        //     );
    }

    isLoggedIn(): boolean {
        return !!localStorage.getItem('access_token');
    }

    // login(email: string, password?: string) {
    //     return this.http.post(`${environment.loginUrl}Account/login`, { email, password });
    // }

    // validateToken() {
    //     return this.http.get(`${environment.apiUrl}Account/ValidatedToken`);
    // }

    signOut(isIsc?: boolean) {
        localStorage.clear();
        this.isLogged = false;
        // this.router.navigate(['/auth']);
        window.location.reload();
    }

    handleError(errorResponse: HttpErrorResponse) {
        if (errorResponse.status === 401) {
            this.signOut();
        }
    }

    refreshSSOToken(token: string, refreshToken: string) {
        return this.http.post(`${environment.apiUrl}Account/refreshSSO`, { token, refreshToken });
    }

    generateApplicationToken() {
        return this.http.get(`${environment.apiUrl}Account/GenerateApplicationToken`);
    }

    getExternalToken(token: string, refreshToken?: string) {
        const data = {
            'Token': token,
            'RefreshToken': refreshToken
        }
        return this.http.post(`${environment.webAuthUrl}Authentication/generateExternalToken`, data);
    }

    handleAuthCallback(): void {
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('access_token');
        if (token) {
            localStorage.setItem('access_token', token);
            this.router.navigate(['/home']); // Redirect to the desired route
        } else {
            if (!!localStorage.getItem('access_token')) {
                // this.router.navigate(['/home']); // Redirect to the desired route
            } else {
                // Handle error if token is not present
                console.error('Token not found in URL');
                window.location.href = environment.loginAppUrl;
            }
        }
    }

    getApplicationsList(userName: any) {
        return this.http.get(`${environment.webAuthUrl}Application/getapplistbyusername?userName=${userName}`);
    }

    refreshAppToken(appName: string, data: any) {
        return this.http.post(`${environment.webAuthUrl}Authentication/refreshapplicationtoken?application=${appName}`, data);
    }

    generateTokenClaim(data: object) {
        return this.http.post(`${environment.webAuthUrl}Authentication/generatetokenclaim`, data);
    }
}
